import { en } from './en'
import { fr } from './fr'

export const companySettings = {
  en,
  fr
}